import { z } from "zod"

const AppEnv = z.union([z.literal("DEVELOPMENT"), z.literal("TEST"), z.literal("STAGING"), z.literal("PRODUCTION")])
export type AppEnv = z.infer<typeof AppEnv>

const rawEnv = import.meta.env.VITE_ENVIRONMENT

if (!rawEnv || typeof rawEnv != "string") {
	throw Error("VITE_ENVIRONMENT was not provided")
}

const parsedEnv = AppEnv.safeParse(rawEnv)

if (!parsedEnv.success) {
	throw Error(`VITE_ENVIRONMENT should be one of "DEVELOPMENT", "TEST", "STAGING", Or "PRODUCTION"`)
}

export const appEnv: AppEnv = parsedEnv.data
